<template>
  <v-select
    v-model="selected"
    :searchable="true"
    :items="dashboardsFormatted"
    :label="$t('components.Onboarding.label.title.selectDashboard')"
    :placeholder="$t('components.Onboarding.label.placeholder.dashboardSelect')"
    :rules="rules"
    :dense="dense"
    :required="required"
    :outlined="outlined"
    :solo="solo"
    @change="selectDashboard(selected)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { MUTATE } from '@/store/modules/mutation_types';

export default {
  name: 'DashboardSelect',
  props: {
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    dense: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: '',
    };
  },
  computed: {
    ...mapState('dashboard', [
      'dashboards',
    ]),
    ...mapGetters('dashboard', [
      'activeDashboard',
    ]),
    dashboardsFormatted() {
      return this.dashboards.map((dashboard) => {
        return {
          text: dashboard.data.title || this.$t('components.Onboarding.label.title.noTitleDasboard'),
          value: dashboard.id,
        };
      });
    },
  },
  methods: {
    ...mapActions('dashboard', [
      'checkForChangeLogs',
    ]),
    ...mapMutations('dashboard', {
      mutateDashboard: MUTATE,
    }),
    selectDashboard() {
      const indexDashboardWithThisId = this.dashboards.findIndex(dashboard => dashboard.id === this.selected);

      if (indexDashboardWithThisId > -1) {
        this.mutateDashboard({
          property: 'activeDashboardIndex',
          with: indexDashboardWithThisId,
        });

        this.checkForChangeLogs(this.activeDashboard);
      }

      this.$emit('select', this.selected);
    },
  },
};
</script>
